<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-form :model="addForm" ref="addFormRef" :inline="true" label-width="80px" class="font-bold">
        <el-form-item label="前客服id" prop="coid" >
          <el-input size="small" v-model="addForm.coid" clearable placeholder="请输入id"></el-input>
        </el-form-item>
        <el-form-item label="后客服id" prop="ctid" >
          <el-input size="small" v-model="addForm.ctid" clearable placeholder="请输入id"></el-input>
        </el-form-item>
        <el-form-item label="客户id" prop="serviceuserid" >
          <el-input size="small" v-model="addForm.serviceuserid" clearable placeholder="请输入id"></el-input>
        </el-form-item>
        <el-form-item label="时间区间" prop="dateValue" >
          <el-date-picker
            v-model="addForm.dateValue"
            size="small"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateRangeChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getTranslateList(true)">搜索</el-button>
          <el-button size="small" @click="resetInput">重置</el-button>
        </el-form-item>

      </el-form>

      <el-table :data="translate" border stripe>
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="Id" prop="Id"></el-table-column>
        <el-table-column label="前客服id" prop="COid"></el-table-column>
        <el-table-column label="后客服id" prop="CTid"></el-table-column>
        <el-table-column label="客户id" prop="ServiceUserId" ></el-table-column>
        <el-table-column label="转移时间" prop="CreatedAt"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
  import { chat_get } from '@/api'

  export default {
    name: 'translate',
    data() {
      return {
        // 获取角色列表的参数对象
        queryInfo: {
          query: '',
          // 当前的页数
          pagenum: 1,
          // 当前每页显示多少条数据
          pagesize: 10
        },
        translate: [],
        total: 0,
        optionStatus: [{
          value: '1',
          label: '已处理'
        }, {
          value: '2',
          label: '未处理'
        }],
        optionType: [{
          value: '1',
          label: '机器人'
        }, {
          value: '2',
          label: '客服'
        }],
        addForm: {
          coid: '',
          ctid: '',
          serviceuserid: '',
          created_start_at: '',
          created_end_at: '',
          dateValue: []
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    created() {
      this.getTranslateList()
    },
    methods: {
      getTranslateList(val = false) {
        if (val) this.queryInfo.pagenum = 1;

        let { coid, ctid, serviceuserid, created_start_at, created_end_at } = this.addForm;
        chat_get(`/admin/v1/transferRecordList?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&coid=${coid}&ctid=${ctid}&serviceuserid=${serviceuserid}&created_start_at=${created_start_at}&created_end_at=${created_end_at}`, {}, res => {
          if (res.status == 200) {
            this.translate = res.data.TransferRecordS;
            this.total = res.data.Count;
          }
        })
      },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getTranslateList()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.getTranslateList()
      },
      resetInput() {
        this.$refs.addFormRef.resetFields()
      },
      dateRangeChange() {
        this.addForm.startTime = this.addForm.dateValue ? this.addForm.dateValue[0] : ''
        this.addForm.endTime = this.addForm.dateValue ? this.addForm.dateValue[1] : ''
      },
    }
  }
</script>

<style scoped>
  .el-icon-circle-close {
    color: white !important;
  }
</style>
